import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as s } from "../../../../IconBase-CxZyIWw2.js";
const t = i((e, l) => /* @__PURE__ */ o.jsx(
  s,
  {
    ref: l,
    ...e,
    image: (r) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9.383 15.97V8.687h2.446l.366-2.84H9.383V4.035c0-.822.229-1.382 1.407-1.382h1.504V.111A20 20 0 0 0 10.103 0C7.935 0 6.452 1.323 6.452 3.753v2.094H4v2.839h2.452v7.285z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "FacebookIcon";
export {
  t as FacebookIcon,
  t as default
};
//# sourceMappingURL=index.js.map
